import React from "react";

function MapIcon() {
  return (
    <svg
      width="11"
      height="15"
      viewBox="0 0 11 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.20312 13.9766C1.21094 8.23438 0.5 7.63281 0.5 5.5C0.5 2.60156 2.82422 0.25 5.75 0.25C8.64844 0.25 11 2.60156 11 5.5C11 7.63281 10.2617 8.23438 6.26953 13.9766C6.02344 14.3594 5.44922 14.3594 5.20312 13.9766ZM5.75 7.6875C6.95312 7.6875 7.9375 6.73047 7.9375 5.5C7.9375 4.29688 6.95312 3.3125 5.75 3.3125C4.51953 3.3125 3.5625 4.29688 3.5625 5.5C3.5625 6.73047 4.51953 7.6875 5.75 7.6875Z"
        fill="#757575"
      />
    </svg>
  );
}

export default MapIcon;
